import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { PickupService } from '../../../data/pickup.service';
import { PickupData } from './pickup.data';
import { pickupTableRequest } from '../../../store/pickup-table/pickup-table.actions';
import { PickupTableService } from '../../shared/tables/pickup-table.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow
} from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-pickup-table',
    templateUrl: './pickup-table.component.html',
    styleUrls: [ './pickup-table.component.scss' ],
    imports: [MatProgressSpinner, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatSortHeader, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, AsyncPipe]
})
export class PickupTableComponent implements OnInit {

    constructor(private store: Store<AppState>, private pickupService: PickupService,
                public table: PickupTableService) {
    }

    dataSource = new PickupData(this.table.currentPageEntries$);

    ngOnInit(): void {
        this.store.dispatch(pickupTableRequest());
    }

}
